module.exports = __webpack_public_path__ + "static/media/6-7.e372519c.mp3";